// extracted by mini-css-extract-plugin
export default {"loaderWrap":"ProfilePhoto_loaderWrap__7ImFk","loaderSpinner":"ProfilePhoto_loaderSpinner__HV0dd"};